import React, { useEffect, useState } from 'react';
import Plot from 'react-plotly.js';

const SpliceBoxPlot = ({ data }) => {
  const [chartData, setChartData] = useState([]);

  const colors = ['#012a4a', '#01497c', '#2a6f97'];

  useEffect(() => {
    const updatedChartData = data.data.map((item, index) => ({
      y: item.data,
      type: 'box',
      name: item.label,
      boxpoints: 'all',
      jitter: 0,
      pointpos: 0,
      marker: {
        color: colors[index % colors.length],
        opacity: 0.2,
      },
      line: {
        color: colors[index % colors.length],
      },
    }));

    setChartData(updatedChartData);
  }, [data]);

  return (
    <Plot
      data={chartData}
      layout={{
        title: data.title,
        yaxis: {
          title: 'Junction Count',
        },
        font: {
          family: 'Lato, sans-serif',
        },
      }}
      config={{ responsive: true }}
      style={{ minWidth: '500px', width: '100%', height: '100%' }}
    />
  );
};

export default SpliceBoxPlot;